import { Link } from "react-router-dom";

import Branding from "../../Branding/Branding";

function LogoImage() {
	const branding = Branding();
	return (
		<>
			<img className="light-mode-item navbar-brand-item" src={branding.logo} alt="logo" style={{ width: "60px", height: "auto" }} />
			<img className="dark-mode-item navbar-brand-item" src={branding.logo_light} alt="logo" style={{ width: "60px", height: "auto" }} />
		</>
	)
}


function BrandingLogo({ to }) {
	const branding = Branding();

	return (
		<Link className="navbar-brand d-flex align-content-center justify-content-center" to={to}>

			<div className="avatar avatar-lg me-2">
				<LogoImage />
			</div>

			<div className="d-none d-sm-block">
				<h3 
						className="light-mode-item navbar-brand-item mt-2" 
						style={{ fontFamily: '"Varela Round", sans-serif', color: "#2a6e43"}}
				>{branding.site_name}</h3>

				<h3 
						className="dark-mode-item navbar-brand-item mt-2" 
						style={{ fontFamily: '"Varela Round", sans-serif', color: "#7beea5"}}
				>{branding.site_name}</h3>
			</div>

		</Link>
	);
}

export default BrandingLogo;

export { LogoImage }